import { apiJson } from '../api';
import type { StoryElement } from '../types';

/**
 * How deep For You goes on load, and how deep "More stories" takes it. The
 * merged feed is served from judgments the half-hour producer has already
 * accumulated, so depth costs a bigger response and nothing else -- but almost
 * nobody reads past the first screen, so the deeper list stays a request.
 */
export const FOR_YOU_DEPTH = 50;
export const FOR_YOU_FULL_DEPTH = 200;

/** Which of the reader's feeds put a story in front of them. */
export interface ForYouMatch {
  id: string;
  name: string;
}

/** A For You row: an ordinary reader story, plus its attribution. */
export type ForYouElement = StoryElement & { for_you_searches?: ForYouMatch[] };

export interface ForYouMembership {
  /** Every feed the reader has, whether or not it is in For You. */
  saved_search_count: number;
  /** The subset merged into the page. */
  member_count: number;
}

export async function listForYouElements(limit = FOR_YOU_DEPTH): Promise<ForYouElement[]> {
  const data = await apiJson<ForYouElement[]>(
    `/api/for-you/elements?limit=${limit}&defer_details=true`,
  );
  return Array.isArray(data) ? data : [];
}

export async function getForYouMembership(): Promise<ForYouMembership> {
  return apiJson<ForYouMembership>('/api/for-you/membership');
}
